import { render } from "./InletHandle.vue?vue&type=template&id=bb8deb58&scoped=true"
import script from "./InletHandle.vue?vue&type=script&lang=js"
export * from "./InletHandle.vue?vue&type=script&lang=js"

import "./InletHandle.vue?vue&type=style&index=0&id=bb8deb58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8deb58"]])

export default __exports__